<div class="about-me-stepper-container" *ngIf="question">
  <div class="about-me-stepper-header" *ngIf="showExitButton">
    <a class="about-me-exit" (click)="saveAndExit()">{{ 'about.me.walkthrough.skip.label' | translate }}</a>
  </div>
  <div class="about-me-stepper-content">
    <h1 class="about-me-question-title">
      {{ question.name }}
    </h1>
    <div class="about-me-question-description">{{ question.description }}</div>
    <div class="about-me-question-answer">
      <ng-container *ngIf="question.options.length > 0 && question.type === 'MULTIPLE'">
        <div *ngIf="showYearsSelect()">
          <div *ngFor="let selectedOption of currentAnswer().options; let o = index">
            @if (selectedOption.years) {
              <div class="about-me-chip about-me-chip-active about-me-chip-with-range">
                <span
                  class="pi pi-times-circle p-chip-icon chip-remove-icon"
                  (click)="onOptionRemove($event, selectedOption.text)"
                ></span>
                <span class="p-chip-label">{{ selectedOption.text }}</span>
                <p-select [options]="allYears()[o]" [(ngModel)]="selectedOption.years" class="about-me-chip-select">
                  <ng-template pTemplate="selectedItem">
                    <div class="flex items-center gap-2" *ngIf="selectedOption.years">
                      <span
                        >{{ selectedOption.years.from }} - {{ selectedOption.years.to }}
                        {{ 'about.me.walkthrough.years.label' | translate }}</span
                      >
                    </div>
                  </ng-template>

                  <ng-template let-year pTemplate="item">
                    <div class="flex align-items-center gap-2">
                      <span>{{ year.from }} - {{ year.to }} {{ 'about.me.walkthrough.years.label' | translate }}</span>
                    </div>
                  </ng-template>
                </p-select>
              </div>
            }
          </div>
        </div>
        <div
          *ngFor="let option of question.options"
          [ngClass]="chipIsActive(option) ? 'about-me-chip about-me-chip-active' : 'about-me-chip'"
          (click)="chipIsActive(option) ? null : onOptionSelect(option)"
        >
          <span
            *ngIf="chipIsActive(option)"
            (click)="onOptionRemove($event, option.text)"
            class="pi pi-times-circle p-chip-icon chip-remove-icon"
          ></span>
          <div class="p-chip-label" data-pc-section="label">{{ option.text }}</div>
          <span
            *ngIf="!chipIsActive(option)"
            (click)="onOptionSelect(option)"
            class="pi pi-plus p-chip-icon chip-add-icon"
          ></span>
        </div>
      </ng-container>
      <ng-container *ngIf="question.open && question.type === 'MULTIPLE'">
        <textarea
          pInputTextarea
          rows="5"
          cols="30"
          placeholder="Placeholder"
          [ngModel]="currentAnswer().text"
          (ngModelChange)="editAnswerText($event)"
          class="about-me-textarea"
        ></textarea>
      </ng-container>
      <ng-container *ngIf="question.type === 'YES_NO'">
        <div class="about-me-yesno-container">
          <div class="about-me-yesno-radios">
            <label class="about-me-yesno-radio" [ngClass]="{ active: this.currentAnswer().yesOrNot === true }">
              <input
                type="radio"
                name="yesno"
                [value]="true"
                [ngModel]="this.currentAnswer().yesOrNot"
                (ngModelChange)="onYesOrNoChange($event)"
              />
              <span class="about-me-yesno-radio-label">{{ 'about.me.walkthrough.yes.please.label' | translate }}</span>
            </label>
            <label class="about-me-yesno-radio" [ngClass]="{ active: this.currentAnswer().yesOrNot === false }">
              <!-- TODO: check if the problem is solved -->
              <input
                type="radio"
                name="yesno"
                [value]="false"
                [ngModel]="this.currentAnswer().yesOrNot"
                (ngModelChange)="onYesOrNoChange($event)"
              />
              <span class="about-me-yesno-radio-label">{{ 'global.no.label' | translate }}</span>
            </label>
          </div>
          <div class="about-me-zones-chips" *ngIf="this.currentAnswer().yesOrNot === true">
            <div
              *ngFor="let option of question.options"
              [ngClass]="chipIsActive(option) ? 'about-me-chip about-me-chip-active' : 'about-me-chip'"
              (click)="chipIsActive(option) ? null : onOptionSelect(option)"
            >
              <span
                *ngIf="chipIsActive(option)"
                (click)="onOptionRemove($event, option.text)"
                class="pi pi-times-circle p-chip-icon chip-remove-icon"
              ></span>
              <div class="p-chip-label" data-pc-section="label">{{ option.text }}</div>
              <span
                *ngIf="!chipIsActive(option)"
                (click)="onOptionSelect(option)"
                class="pi pi-plus p-chip-icon chip-add-icon"
              ></span>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="about-me-stepper-footer">
    <button *ngIf="currentStep > 0" type="button" class="about-me-back-btn" (click)="onPreviousStep()">
      <span class="about-me-back-btn-icon pi pi-chevron-left"></span>
    </button>
    <div class="about-me-stepper">
      <ng-container *ngFor="let step of [].constructor(totalSteps); let i = index">
        <span class="about-me-stepper-dot" [ngClass]="{ active: i === currentStep, completed: i < currentStep }"></span>
      </ng-container>
    </div>
    <button pButton type="button" class="about-me-continue-btn" (click)="onNextStep()">
      {{ 'about.me.walkthrough.continue.label' | translate }}
    </button>
  </div>
</div>
